import * as Sentry from "@sentry/browser";

// Configuration is supplied by the server as a non-executable JSON data block so that
// no per-site values are baked into this shared bundle and no inline script is required
// (keeping us within the Content-Security-Policy script-src restrictions). See the
// `error-reporting` tag helper in DSE.Core.Web.Core.
const ConfigElementId = "dse-error-reporting-config";

interface ErrorReportingUser {
  id?: string;
  email?: string;
}

interface ErrorReportingConfig {
  dsn?: string;
  environment?: string;
  release?: string;
  tunnel?: string;
  user?: ErrorReportingUser;
}

function readConfig(): ErrorReportingConfig | null {
  const element = document.getElementById(ConfigElementId);

  if (!element?.textContent) {
    return null;
  }

  try {
    return JSON.parse(element.textContent) as ErrorReportingConfig;
  } catch {
    return null;
  }
}

const config = readConfig();

// Without a DSN there is nothing to report to — initialising Sentry would be a no-op
// transport, so we skip it entirely. This keeps the bundle inert until a site is
// configured (and lets us ship the bundle ahead of the per-site DSNs being set).
if (config?.dsn) {
  Sentry.init({
    dsn: config.dsn,
    environment: config.environment,
    release: config.release,
    // Route all envelopes (errors and tracing) through a same-origin endpoint so that
    // ad blockers, which target requests to sentry.io, do not drop them.
    tunnel: config.tunnel,
    sendDefaultPii: true,
    attachStacktrace: true,
    integrations: [Sentry.browserTracingIntegration()],
  });

  if (config.user && (config.user.id || config.user.email)) {
    Sentry.setUser({
      id: config.user.id,
      email: config.user.email,
    });
  }
}
